import _ from "lodash";
import { Search } from "../../filtering";

const mapSearchFields: any = {
    general1: 'generalText1',
    general2: 'generalText2',
    general3: 'generalText3',
    date: { from: 'dateFrom', to: 'dateTo' },
    date1: { from: 'dateFrom1', to: 'dateTo1' },
    date2: { from: 'dateFrom2', to: 'dateTo2' },
    number: { from: 'numberFrom', to: 'numberTo' },
    number1: { from: 'numberFrom1', to: 'numberTo1' },
    number2: { from: 'numberFrom2', to: 'numberTo2' },
}

/**
 * Revision History
 * 
 * 12/13/2021   ptkim           Base class for all ???ListItem class
 */
export class SearchModelBase {
    descending: boolean = false;
    orderByEta: boolean = false;
    searchField: string[] = [];
    excludeOrderByField: string[] = [];
    recCount: number = 0;
    isSearch: boolean = false;
    extraWhere: String = '';
    [x: string]: any;
    isExpressSearch: boolean = false;



    /**
     * 
     * @param search Conversion from Search model used on list screens to search model supported by api.getListItems
     *      Filtering can be customized. Check OeMblListItem for details.
     * @param customSearchFieldMap 
     * @param customizedFields - pass list of fields that use customized renderers. For those fields - use value as is provided without any changes (like adding % to beginning) 
     * @returns 
     */
    public static calculateSearchParameters(search: Search, customSearchFieldMap: { [key: string]: { [key: string]: string } } = {}, customizedFields: Array<string> = [], aiAgentFieldName: string = 'u1ID' ) {
        const result: Partial<SearchModelBase> = { ...search };
        const searchFields = new Set<string>();
        (Object.keys(search) as Array<keyof Search>).forEach((key) => {
            if (search[key] && (mapSearchFields[key] !== null && mapSearchFields[key] !== undefined)) {
                if (typeof search[key] === 'string') {
                    if (typeof mapSearchFields[key] === 'object') {
                        if (customSearchFieldMap[search[key] as string]) {
                            // @ts-ignore
                            result[customSearchFieldMap[search[key]].from] = search[mapSearchFields[key].from];
                            // @ts-ignore
                            result[customSearchFieldMap[search[key]].to] = search[mapSearchFields[key].to];
                            searchFields.add(search[key] as string);
                        }
                    } else {
                        // @ts-ignore
                        if (search[mapSearchFields[key]] === true || search[mapSearchFields[key]] === false) {
                            // Handle boolean values

                            // @ts-ignore
                            result[search[key]] = !!search[mapSearchFields[key]];
                            searchFields.add(search[key] as string);
                        }
                        // @ts-ignore
                        // else if (!isNaN(search[mapSearchFields[key]])) {
                        //     // Handle integers

                        //     // @ts-ignore
                        //     result[search[key]] = search[mapSearchFields[key]];
                        //     searchFields.add(search[key] as string);
                        // }
                        //else if (search[mapSearchFields[key]] || (search.generalNullOrEmpty || nullSearchEnableColumns.some(x => x === search[key]))) {
                        else {
                            // @ts-ignore
                            if (customizedFields.includes(search[key])) {
                                // @ts-ignore
                                result[search[key]] = search[mapSearchFields[key]]
                                searchFields.add(search[key] as string);
                            }
                            else {
                                // @ts-ignore
                                const value = search[mapSearchFields[key]];
                                const option = search.searchConditions.find(x => x.fieldName === search[key])?.condition;
                                // @ts-ignore
                                result[search[key]] = applySearchOption(value, option);
                                searchFields.add(search[key] as string);
                            }
                        }
                    }
                }
            }
            else if (key === 'extras' && _.isArray(search[key]) && search[key].length > 0) {
                search[key].forEach(x => {
                    Object.keys(x).forEach(y => {
                        if (y === 'extraSlot') {
                            if (x['dateFrom'] || x['dateFrom']) {
                                // @ts-ignore
                                result[customSearchFieldMap[x[y]].from] = x['dateFrom'];
                                // @ts-ignore
                                result[customSearchFieldMap[x[y]].to] = x['dateTo'];
                            }
                            else if (x['numberFrom'] || x['numberTo']) {
                                // @ts-ignore
                                result[customSearchFieldMap[x[y]].from] = x['numberFrom'];
                                // @ts-ignore
                                result[customSearchFieldMap[x[y]].to] = x['numberTo'];
                            }
                            else {
                                // @ts-ignore
                                if (x['generalText'] === true || x['generalText'] === false) {
                                    // @ts-ignore
                                    result[x[y]] = !!x['generalText'];
                                }
                                //else if (x['generalText'] || search.generalNullOrEmpty) {
                                else {
                                    // @ts-ignore
                                    if (customizedFields.includes(x[y])) {
                                        // @ts-ignore
                                        result[x[y]] = x['generalText']
                                    }
                                    else {
                                        // @ts-ignore
                                        const fieldName = x[y];
                                        const option = search.searchConditions.find(x => x.fieldName === fieldName)?.condition;
                                        result[fieldName] = applySearchOption(x.generalText, option);
                                    }
                                }
                            }
                            // @ts-ignore
                            searchFields.add(x[y] as string);
                        }
                    })
                })
            }
        });

       if (search.createdByAiAgent) {
            result[aiAgentFieldName] = '@aiagent';
            searchFields.add(aiAgentFieldName);
        }

        // @ts-ignore
        result.searchField = [...searchFields.values(), ...result.searchField ?? []]; //<pt220904>
        result.isSearch = result.searchField.length > 0
        result.excludeOrderByField = []
        result.descending = !result.orderByAscending
        result.isExpressSearch = result.isExpressSearch

        return result;
    }
}

function applySearchOption(value: string | null, option?: number) {
    if (!value) return null;
  
    const escaped = value.replace(/'/g, "''");
  
    return option === 0 ? `%${escaped}` : escaped;
  }